export default "/_next/static/d80eddb6e81986f7d162da40bfb45e9f.png";